import { createFileRoute, Link } from "@tanstack/react-router";

import { ClientVisionView } from "~/components/engagement/planning/client-vision-view";
import { useUserInfoForEngagement } from "~/lib/queries/engagementQuery";

export const Route = createFileRoute(
  "/_user/my-coaching/clients/programs/$engagementId/client-vision",
)({
  staticData: { title: "Client's vision" },
  component: ClientVisionPage,
});

function ClientVisionPage() {
  const { engagementId } = Route.useParams();
  const { data: userInfo } = useUserInfoForEngagement(engagementId);

  return (
    <ClientVisionView
      clientId={userInfo?.userId}
      renderCategoryLink={(categoryId, tile) => (
        <Link
          to="/my-coaching/clients/programs/$engagementId/vision/$categoryId"
          params={{ engagementId, categoryId }}
          className="group block"
        >
          {tile}
        </Link>
      )}
    />
  );
}
